import { isClient } from 'legacyfrontend/helpers/ssr-helper';

export const scrollToTop = () => {
  if (isClient) {
    isClient &&
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
  }
};
